import { event } from "vue-gtag";

function isCalendlyEvent(e) {
  return e.origin === "https://calendly.com" && e.data.event && e.data.event.indexOf("calendly.") === 0;
}

function isQrgBookingEvent(e) {
  return e.data && typeof e.data.event === "string" && e.data.event.startsWith("qrgbooking.");
}

export function trackBookingEventTypeViewed() {
  event("agent_showing_viewed");
}

export function trackBookingDateAndTimeSelected() {
  event("agent_showing_date_time_selected");
}

/** QRG widget `qrgbooking.event_scheduled` / Calendly `calendly.event_scheduled`. */
export function trackBookingEventScheduled() {
  event("agent_showing_booked");
}

export default function bookingMessageHandler(e) {
  if (isCalendlyEvent(e)) {
    switch (e.data.event) {
      case "calendly.event_type_viewed":
        trackBookingEventTypeViewed();
        break;
      case "calendly.date_and_time_selected":
        trackBookingDateAndTimeSelected();
        break;
      case "calendly.event_scheduled":
        trackBookingEventScheduled();
        break;
    }
  } else if (isQrgBookingEvent(e)) {
    switch (e.data.event) {
      case "qrgbooking.event_type_viewed":
        trackBookingEventTypeViewed();
        break;
      case "qrgbooking.date_and_time_selected":
        trackBookingDateAndTimeSelected();
        break;
      case "qrgbooking.event_scheduled":
        trackBookingEventScheduled();
        break;
    }
  }
}
